import { Canvas } from "@react-three/fiber"
import { Box, Environment, Html, OrbitControls, PerspectiveCamera } from "@react-three/drei"
import { Suspense, useEffect, useRef, useState } from "react"
import ProductModel from "./ProductModel"
import PresentationCamera from "./PresentationCamera"
import { Perf } from "r3f-perf"
import Interface from "./ui/Interface"
import { useCounterStore } from "./stores/CounterStore"
import { RoomBaked } from "./RoomBaked"
import Loader from "./Loader"
import { createClient } from "@supabase/supabase-js"
import { TV } from "./TV"
import { RoomDecorado } from "./RoomDecorado"
import { useColorStore } from "./stores/ColorStore"

export default function App(props) {
    const supabase = createClient('https://ywdvmyrishxdrpupzvfj.supabase.co', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inl3ZHZteXJpc2h4ZHJwdXB6dmZqIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzcxMzQ2ODgsImV4cCI6MTk5MjcxMDY4OH0.9_3HmDf07QhUQFWihZcXAMYYU137k0PU5Kn3s5ZVFr8')
    const currentMode = "explore"//"explore/customize/vr-explorecustomization"

    const [language, setLanguage] = useState(props.lang)

    const canvas = useRef()

    const assignCamId = useCounterStore((state) => state.assign)
    const camId = useCounterStore((state) => state.camTransformId)

    const [spots, setSpots] = useState([])
    const [models, setModels] = useState([])
    const [currentSpot, setCurrentSpot] = useState()

    const assignBodyColor = useColorStore((state) => state.assignBody)
    const assignCapColor = useColorStore((state) => state.assignCap)

    useEffect(() => { // TODO - Add loader while fetching data
        async function fetchSpotsAndModels() {
            const _spots = await supabase.from('spots').select('*')
            const _models = await supabase.from('models').select('*')
            setSpots(_spots.data)
            setModels(_models.data)
        }
        fetchSpotsAndModels()
    }, [])

    const [modelData, setModelData] = useState({
        id: "",
        data: {
            capColors: "",
            bodyColors: "",
            EN: {
                label: "",
                title: "Title",
                subtitle: "Subt"
            },
            ES: {
                label: "",
                title: "Title",
                subtitle: "Subt"
            },
            FR: {
                label: "",
                title: "Title",
                subtitle: "Subt"
            },
            IT: {
                label: "",
                title: "Title",
                subtitle: "Subt"
            },
            DE: {
                label: "",
                title: "Title",
                subtitle: "Subt"
            }
        },
        url: "",
        template_url: ""
    })

    useEffect(() => {
        if (currentSpot == undefined || models == []) return;
        const model = models.find(_model => _model.id === currentSpot.model_id)

        setModelData(model)
        if(model.data.bodyColors != undefined) {
            if(model.data.bodyColors.split(",")[0] != undefined) {
                // console.log(model.data.bodyColors.split(",")[0])
                assignBodyColor(model.data.bodyColors.split(",")[0])
            }
        } else {
            assignBodyColor("white")
        }

        if(model.data.capColors != undefined) {
            if(model.data.capColors.split(",")[0] != undefined) {
                assignCapColor(model.data.capColors.split(",")[0])
            }
        } else {
            assignCapColor("black")
        }
    }, [currentSpot])

    return <>
        <Canvas gl={{ preserveDrawingBuffer: true }} ref={canvas}>
            <Suspense fallback={<Loader />}>
                {/* <Perf position="bottom-left" deepAnalyze ></Perf> */}

                {currentMode == "customize"
                    ? <>
                        <PerspectiveCamera fov={75} makeDefault position={[-0.5, 1.65, 4.2]} />
                        <OrbitControls position={[-2.5, 1.65, 0.2]} />
                    </>
                    : <PresentationCamera />}

                {/* <Environment background="only" preset="park"></Environment> */}
                <Environment background="only" files={"rooitou_park_1k.hdr"}></Environment>
                <directionalLight rotation={[30, 50, 15]}></directionalLight>
                {/* <pointLight intensity={0.5} position={[0, 2, 0]}></pointLight> */}
                {/* <pointLight distance={.5} intensity={2} position={[-2.75, 1.85, -.25]}></pointLight> */}
                {/* <pointLight distance={.5} intensity={120} position={[-2.65, 1.85, -.25]}></pointLight> */}
                <ambientLight intensity={.2} color="#DDDDFF"></ambientLight>

                <pointLight position={[-1.7, 1.9, 0.15]} distance={2.8}></pointLight>
                <pointLight position={[-1.7, 2.4, -2.8]} distance={3.4}></pointLight>
                {/* <Box scale={.35} position={[-1.7, 1.9, 0.15]}></Box>
                <Box scale={.35} position={[-1.7, 2.4, -2.8]}></Box> */}

                {/* FLOATING LABELS */}
                {camId == 0 ?
                    <>
                        <Html distanceFactor={10} position={[-3.67, 3, -1.2]}>
                            <div className="annotation" onClick={() => assignCamId(2)}>
                                WATER BOTTLES AND CANS
                            </div>
                        </Html>
                        <Html distanceFactor={10} position={[-3.67, 3.7, -4.5]}>
                            <div className="annotation" onClick={() => assignCamId(7)}>
                                GLASS WATER BOTTLES
                            </div>
                        </Html>
                        {/* <Html distanceFactor={10} position={[3.67, 2.55, -2.5]}>
                            <div className="annotation" onClick={() => assignCamId(3)}>
                                OTHER
                            </div>
                        </Html> */}
                        <Html distanceFactor={10} position={[3.67, 2.85, 1.65]}>
                            <div className="annotation" onClick={() => assignCamId(4)}>
                                COUNTER
                            </div>
                        </Html>
                    </> : <></>
                }
                {camId == 7 ?
                    <Html distanceFactor={12} position={[-2.7, 2.1, -2.6 ]}>
                        <div className="annotationSmall" onClick={() => assignCamId(2)}>
                            BOTTLES
                        </div>{/* Redirect */}
                    </Html> 
                : <></>}
                {camId == 2 ?
                    <Html distanceFactor={12} position={[-2.9, 2.3, -1.9]}>
                        <div className="annotationSmall" onClick={() => assignCamId(7)}>
                            GLASS BOTTLES
                        </div>{/* Redirect */}
                    </Html> 
                : <></>}

                <RoomBaked></RoomBaked>
                <RoomDecorado></RoomDecorado>
                <TV></TV>
                {spots.map((_spot, index) => (
                    <Suspense key={index}>
                        <ProductModel
                            position={currentSpot === _spot.id && camId == 5
                                ? [_spot.data.position[0], _spot.data.position[1] + 0.02, _spot.data.position[2]]
                                : _spot.data.position
                            }
                            canRotate={camId == 5} // TODO - Update EN for language variable
                            labelText={models.find(_model => _model.id === _spot.model_id).data[language].label}
                            modelId={_spot.model_id}
                            setCurrentSpot={() => setCurrentSpot(_spot)}
                            isBeingEdited={currentSpot?.id === _spot.id}
                            materialSettings={JSON.parse(models.find(_model => _model.id === _spot.model_id).data.materialSettings)}
                        // productModel??
                        />
                    </Suspense>
                ))}
            </Suspense>
        </Canvas>
        <Interface 
            model={modelData} 
            spots={spots}
            setSpots={setSpots} 
            models={models} 
            setCurrentModel={setModelData} 
            canvas={canvas}
            language={language}
            setLang={(newLang) => setLanguage(newLang)}
        />
    </>
}
